import WXAPI from './wxAPI'

// webapp微信分享处理标题和显示图片
export const wxRegister = (isProductDetail = false, shareConfig = {}) => {
  const link = window.location.href
  const { proTitle, proDesc, proImg } = shareConfig
  let params = {
    link: link,
    success: function (res) {
      console.log(res)
    },
    fail: function (err) {
      console.log(err)
    }
  }
  let extraParams = isProductDetail
    ? { title: `${proTitle}`, imgUrl: proImg, desc: proDesc }
    : { title: '暂无标题', imgUrl: '', desc: '暂无' }
  let wx = new WXAPI(Object.assign({}, params, extraParams))
  wx.bootWx()
}
